import { useState, useCallback } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import ToastMsg from "../../components/ToastMsg";
import PortalPopup from "../../components/PortalPopup";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import NavigationPanel from "../../components/NavigationPanel";
import Breadcrumb from "../../components/Breadcrumb";
import CTAs from "../../components/CTAs";
import Footer from "../../components/Footer";
import SettingNav from "../../components/settingNav";

const SettingsBilling2Page = () => {
  const navigate = useNavigate();
  const [isToastMsgOpen, setToastMsgOpen] = useState(false);
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);

  const onBillingTextClick = useCallback(() => {
    navigate("/setting-billing");
  }, [navigate]);

  const onInvoicePreviewTextClick = useCallback(() => {
    // Add your code here
  }, []);

  const onClickGeneral = useCallback(() => {
    navigate("/setting-general");
  }, [navigate]);

  const onClickPreferences = useCallback(() => {
    navigate("/setting-preferences");
  }, [navigate]);

  const onClickLBAConfig = useCallback(() => {
    navigate("/setting-lbaconfig");
  }, [navigate]);

  const onClickLegalProceedings = useCallback(() => {
    navigate("/setting-legalproceedings");
  }, [navigate]);

  const onClickAIIntegration = useCallback(() => {
    navigate("/setting-aiintegration");
  }, [navigate]);

  const onClickSecurity = useCallback(() => {
    navigate("/setting-security");
  }, [navigate]);

  const onClickHelpSupport = useCallback(() => {
    navigate("/setting-help&support");
  }, [navigate]);

  const onClickDataManagement = useCallback(() => {
    navigate("/setting-datamanagement");
  }, [navigate]);

  const onClickAccount = useCallback(() => {
    navigate("/setting-account");
  }, [navigate]);

  const openToastMsg = useCallback(() => {
    setToastMsgOpen(true);
  }, []);

  const closeToastMsg = useCallback(() => {
    setToastMsgOpen(false);
  }, []);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  return (
    <>
      <div className="w-full relative bg-neutrals-neutral-50 min-h-screen overflow-visible text-left text-sm text-neutrals-neutral-900 font-open-sans-ff-body-strong">
        {/* Navigation Panel */}
        <NavigationPanel />

        {/* Main */}
        <div className="w-full absolute top-[136px] flex flex-col items-start justify-start gap-6 px-4 md:px-4 lg:px-24 box-border">
          {/* Heading */}
          <div className="self-stretch bg-white border-neutrals-neutral-100 border-solid border-b-[1px] flex flex-col items-start justify-start pt-0 px-0 pb-6 gap-1.5 text-9xl text-primary-primary-900">
            <b className="self-stretch relative">Settings</b>
            <div className="self-stretch relative text-base text-neutrals-neutral-300">
              Get your billing information, generate/review invoices.
            </div>
          </div>

          <div className="self-stretch flex flex-row items-start justify-start gap-8 text-base">
            {/* Tabs */}
            <SettingNav />

            {/* Right side */}
            <div className="flex-1 flex flex-col items-start justify-start gap-6 text-lg text-neutrals-neutral-900">
              <div className="self-stretch border-neutrals-neutral-100 border-solid border-b-[1px] flex flex-row items-start justify-between pt-0 px-0 pb-6 gap-0">
                <div className="flex-1 flex flex-col items-start justify-start gap-1.5">
                  <div className="self-stretch relative font-semibold">
                    Payment method
                  </div>
                  <div className="self-stretch relative text-sm text-neutrals-neutral-300">
                    Update your billing details and address.
                  </div>
                </div>
                <div className="flex flex-row items-start justify-start gap-3 text-sm">
                  <CTAs
                    type="Ghostbtn"
                    text="Cancel"
                    textColor="text-neutrals-neutral-900"
                    bgColor="bg-neutrals-neutral-50"
                    borderColor="border-neutrals-neutral-100"
                    position="relative"
                  />

                  <CTAs
                    type="Primarybtn"
                    text="Save"
                    textColor="text-neutrals-neutral-50"
                    bgColor="bg-primary-primary-500"
                    borderColor="border-primary-primary-500"
                    position="relative"
                    onClick={openToastMsg}
                  />
                </div>
              </div>
              <div className="self-stretch flex flex-col items-start justify-start gap-6">
                <div className="text-base font-semibold">Card details</div>
                <div className="self-stretch flex flex-col items-start justify-start gap-6">
                  {/* Card details info */}
                  <div className="self-stretch flex flex-col items-start justify-start gap-[10px] text-base">
                    <div className="flex flex-row items-center justify-start gap-[6px] text-sm">
                      <div className="relative font-semibold">Card details</div>
                      <img
                        className="w-5 relative h-5 overflow-hidden shrink-0"
                        alt=""
                        src="assets/help-circle.svg"
                      />
                    </div>
                    <div className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border overflow-hidden flex flex-row items-center justify-start p-3 border-[1px] border-solid border-neutrals-neutral-100">
                      <div className="relative">1234 1234 1234 1234</div>
                    </div>
                    <div className="flex flex-row items-start justify-start gap-[24px]">
                      <div className="w-[188px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border overflow-hidden shrink-0 flex flex-row items-center justify-start p-3 border-[1px] border-solid border-neutrals-neutral-100">
                        <div className="relative">06/24</div>
                      </div>
                      <div className="w-[188px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border overflow-hidden shrink-0 flex flex-row items-center justify-start p-3 border-[1px] border-solid border-neutrals-neutral-100">
                        <div className="relative">123</div>
                      </div>
                    </div>
                  </div>
                  {/* Email address */}
                  <div className="self-stretch flex flex-col items-start justify-start gap-1 text-sm">
                    <div className="flex flex-col items-start justify-start gap-[10px]">
                      <div className="flex flex-row items-center justify-start gap-[6px]">
                        <div className="relative font-semibold">
                          Email address
                        </div>
                        <img
                          className="w-5 relative h-5 overflow-hidden shrink-0"
                          alt=""
                          src="assets/help-circle.svg"
                        />
                      </div>
                      <div className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border overflow-hidden flex flex-row items-center justify-start p-3 text-base border-[1px] border-solid border-neutrals-neutral-100">
                        <div className="flex-1 relative">pm@thinkai.io</div>
                      </div>
                    </div>
                    {/* Add another option */}
                    <div className="rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-center py-2.5 px-3.5">
                      <div className="flex flex-row items-center justify-center gap-[6px]">
                        <img
                          className="w-5 relative h-5"
                          alt=""
                          src="assets/add.svg"
                        />
                        <div className="relative font-semibold">
                          Add another
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Address and city */}
                  <div className="self-stretch flex flex-row items-start justify-start gap-6 text-sm">
                    {/* Address */}
                    <div className="flex flex-col items-start justify-start gap-[10px]">
                      <div className="flex flex-row items-center justify-start gap-[6px]">
                        <div className="relative font-semibold">Address</div>
                        <img
                          className="w-5 relative h-5 overflow-hidden shrink-0"
                          alt=""
                          src="assets/help-circle.svg"
                        />
                      </div>
                      <div className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border overflow-hidden flex flex-row items-center justify-start p-3 text-base border-[1px] border-solid border-neutrals-neutral-100">
                        <div className="relative">21 Turning St.</div>
                      </div>
                    </div>
                    {/* City */}
                    <div className="flex flex-col items-start justify-start gap-[10px]">
                      <div className="flex flex-row items-center justify-start gap-[6px]">
                        <div className="relative font-semibold">City</div>
                        <img
                          className="w-5 relative h-5 overflow-hidden shrink-0"
                          alt=""
                          src="assets/help-circle.svg"
                        />
                      </div>
                      <div className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border overflow-hidden flex flex-row items-center justify-start p-3 text-base border-[1px] border-solid border-neutrals-neutral-100">
                        <div className="flex-1 relative">Southampton</div>
                      </div>
                    </div>
                  </div>
                  {/* Postcode */}
                  <div className="self-stretch flex flex-col items-start justify-start gap-2 text-sm">
                    <div className="flex flex-row items-center justify-start gap-[6px]">
                      <div className="relative font-semibold">Postcode</div>
                      <img
                        className="w-5 relative h-5 overflow-hidden shrink-0"
                        alt=""
                        src="assets/help-circle.svg"
                      />
                    </div>
                    <div className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border overflow-hidden flex flex-row items-center justify-start p-3 text-base border-[1px] border-solid border-neutrals-neutral-100">
                      <div className="relative">SO14 5FF</div>
                    </div>
                  </div>
                  {/* Country */}
                  <div className="self-stretch flex flex-col items-start justify-start gap-2 text-sm">
                    <div className="flex flex-row items-start justify-start gap-[6px]">
                      <div className="relative font-semibold">Country</div>
                      <img
                        className="w-5 relative h-5 overflow-hidden shrink-0"
                        alt=""
                        src="assets/help-circle.svg"
                      />
                    </div>
                    <div className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border flex flex-row items-end justify-start py-3.5 px-2.5 gap-[175px] text-base border-[1px] border-solid border-neutrals-neutral-100">
                      <div className="w-[162px] relative font-semibold inline-block shrink-0">
                        United kingdom
                      </div>
                      <img
                        className="w-5 relative h-5 overflow-hidden shrink-0"
                        alt=""
                        src="assets/arrow-down.svg"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Footer */}
          <Footer />
        </div>
      </div>
      {isToastMsgOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeToastMsg}
        >
          <ToastMsg onClose={closeToastMsg} />
        </PortalPopup>
      )}
      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
    </>
  );
};

export default SettingsBilling2Page;
